import React from "react";
import { get } from "lodash";
import { useSelector } from "react-redux";
import TooltipWithIcon from '../../Tooltip/WithIcon';
import style from "./style.module.css";
import common from "../Input/style.module.css"

export default function FormGroup(props) {
    const {
        children = false,
        label = false,
        required = false,
        focus = false,
        value = "",
        meta = {},
        helpText = true,
        inputType = "",
        disabled = false,
        className = "",
        tooltip = false,
        fieldName = "",
        fieldValue = "",
    } = props;

    const { touched = false, error = "", form } = meta;
    const isShow = touched && error && helpText && !disabled;

    const empty = {};
    const aiData = useSelector((state) => get(state, `form.${form}.initial.ai_data`, empty));
    const predictionScore = get(aiData, `${fieldName}.prediction_score`, 1);
    const isPredictionCheck = (fieldValue || fieldValue === 0) && predictionScore < 0.7 && !touched && !error;

    return (
        <div className={`${style.formGroup}${style[className] ? ` ${style[className]}` : ``}`}>
            {
                label !== false && (
                    <div className={`${style.controlLabel}${focus || value ? " " + style.focus : ""}${disabled ? " " + style.inputDisabled : ""}${inputType ? " " + style[inputType] : ""}`}>
                        <span dangerouslySetInnerHTML={{ __html: label }}></span>
                        {
                            required && (
                                <span className={style.required}> *</span>
                            )
                        }
                        {
                            tooltip !== false && (
                                <TooltipWithIcon {...props}>{tooltip}</TooltipWithIcon>
                            )
                        }
                    </div>
                )
            }
            <div className={`${style.input}${(isShow || isPredictionCheck) ? " " + style.inputError : ""}${focus ? " " + style.inputFocus : ""}${inputType && isShow ? " " + style[`${inputType}Error`] : ""}`}>
                {
                    disabled === false && (children)
                }
                {
                    disabled === true && (
                        <div className={`${common.textbox} ${style.inputDisabled}`}>
                            {value || <>&nbsp;</>}
                        </div>
                    )
                }
            </div>
            {
                isShow === true && (
                    <p className={`error-message ${style.helpBlock}`}>{error}</p>
                )
            }
            {
                isPredictionCheck === true && (
                    <p className={`error-message ${style.helpBlock}`}>Verify this</p>
                )
            }
        </div>
    )
}